import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "customPath": "/models/kodiaq",
  "description": "ŠKODA KODIAQ это эффектный дизайн ✔️ просторный салон ✔️ великолепная функциональность и набор самых современных электронных систем. Ознакомьтесь подробнее с техническими характеристиками, с дизайном модельного ряда 2023 на официальном сайте ŠKODA в России.",
  "huggerTemplate": "default",
  "keywords": "kodiaq",
  "name": "kodiaq",
  "title": "Купить SKODA KODIAQ 2023/2022 – обновленный Шкода Кодиак на официальном сайте SKODA",
  "schemaOrg": "Product"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const QueriedShowroomMainStage = makeShortcode("QueriedShowroomMainStage");
const SaleEvent = makeShortcode("SaleEvent");
const DefaultPaddedSection = makeShortcode("DefaultPaddedSection");
const DefaultSectionHeading = makeShortcode("DefaultSectionHeading");
const DefaultSectionText = makeShortcode("DefaultSectionText");
const DefSectionBtnContainer = makeShortcode("DefSectionBtnContainer");
const Button = makeShortcode("Button");
const Heading = makeShortcode("Heading");
const FeaturesSliderQueried = makeShortcode("FeaturesSliderQueried");
const ShowRoomTextBlock = makeShortcode("ShowRoomTextBlock");
const ShowRoomTextBlockTitle = makeShortcode("ShowRoomTextBlockTitle");
const ShowRoomTextBlockText = makeShortcode("ShowRoomTextBlockText");
const ShowRoomTextBlockBtnsWrap = makeShortcode("ShowRoomTextBlockBtnsWrap");
const QueriedGallery = makeShortcode("QueriedGallery");
const QueriedDisclaimer = makeShortcode("QueriedDisclaimer");
const CustomIFrame = makeShortcode("CustomIFrame");
const AvnWidget = makeShortcode("AvnWidget");
const VideoPlayer = makeShortcode("VideoPlayer");
const PaddedTilesContainer = makeShortcode("PaddedTilesContainer");
const PaddedTilesTile = makeShortcode("PaddedTilesTile");
const Slider = makeShortcode("Slider");
const SlideIcon = makeShortcode("SlideIcon");
const QueriedDlNew = makeShortcode("QueriedDlNew");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <QueriedShowroomMainStage tags="KODIAQ-FL" withSchemaOrg mdxType="QueriedShowroomMainStage" />
    <SaleEvent tags="saleevent-kodiaq-1" mdxType="SaleEvent" />
    <SaleEvent tags="saleevent-kodiaq-2" mdxType="SaleEvent" />
    <SaleEvent tags="saleevent-kodiaq-3" mdxType="SaleEvent" />
    <DefaultPaddedSection bgColor="#FFF" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading"> НЕЗАБЫВАЕМЫЕ МОМЕНТЫ </DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    Обновленный ŠKODA KODIAQ — практически идеальный семейный автомобиль. В
    стандартном 5‑местном варианте или с дополнительным третьим рядом в
    7‑местной версии. KODIAQ сохранил прежние достоинства и приобрёл новые.
  </DefaultSectionText>
  <DefSectionBtnContainer mdxType="DefSectionBtnContainer">
    <Button glyph="download" href="/m/catalogs/kodiaq-catalogue.pdf" mdxType="Button">
      Скачать каталог
    </Button>
    <Button href="https://cc.skoda-avto.ru/models/kodiaq" mdxType="Button">Конфигуратор</Button>
  </DefSectionBtnContainer>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#767676" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">
    <Heading size="h3" color="white" bold center mdxType="Heading">
      ВИДЕОПРЕЗЕНТАЦИЯ ОБНОВЛЕННОГО ŠKODA&nbsp;KODIAQ
    </Heading>
  </DefaultSectionHeading>
  <DefSectionBtnContainer mdxType="DefSectionBtnContainer">
    <Button href="/models/kodiaq/video" mdxType="Button">Смотреть</Button>
  </DefSectionBtnContainer>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FAFAFA" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading"> Особенности </DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    ŠKODA KODIAQ — успешный представитель SUV, класса, объединяющего кроссоверы
    и внедорожники.
  </DefaultSectionText>
  <FeaturesSliderQueried tags="kodiaq-fl-overview" filterTags={[{
        name: "Дизайн",
        tag: "design"
      }, {
        name: "Мультимедиа",
        tag: "multimedia"
      }, {
        name: "Безопасность",
        tag: "safety"
      }, {
        name: "Комфорт",
        tag: "comfort"
      }]} mdxType="FeaturesSliderQueried" />
    </DefaultPaddedSection>
    <ShowRoomTextBlock desktopPic="/m/kodiaq-virt-test-kv-new.jpg" mobilePic="/m/kodiaq-virt-test-kv-new.jpg" model="karoq" cssStyle="@media only screen and (max-width: 768px) {text-align: center;};" mdxType="ShowRoomTextBlock">
  <ShowRoomTextBlockTitle mdxType="ShowRoomTextBlockTitle">
    ПРОЙДИТЕ ВИРТУАЛЬНЫЙ ВНЕДОРОЖНЫЙ ТЕСТ-ДРАЙВ
  </ShowRoomTextBlockTitle>
  <ShowRoomTextBlockText main key="main" mdxType="ShowRoomTextBlockText">
    Виртуальный тест-драйв проходит по живописной лесной и off-road трассе с
    препятствиями, изучите ŠKODA KODIAQ в формате 360 с возможностью
    переключения между камерами, не выходя из дома.
  </ShowRoomTextBlockText>
  <ShowRoomTextBlockBtnsWrap mdxType="ShowRoomTextBlockBtnsWrap">
    <Button type="primary" size="small" href="https://virtual-test-drive.skoda-avto.ru/newkodiaq?initialMode=onlyvirtualtestdrive" style={{
          margin: "0 auto"
        }} mdxType="Button">
      ПРОЙТИ ВИРТУАЛЬНЫЙ ТЕСТ-ДРАЙВ
    </Button>
  </ShowRoomTextBlockBtnsWrap>
    </ShowRoomTextBlock>
    <QueriedGallery presetName="5" type="modal" tags="kodiaq-fl-inter-exter" filterTags={[{
      name: "экстерьер",
      tag: "exterior"
    }, {
      name: "интерьер",
      tag: "interior"
    }]} mdxType="QueriedGallery" />
    <DefaultPaddedSection noPb bgColor="#FFF" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">КОМПЛЕКТАЦИИ</DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    Семейный внедорожник доступен в комплектациях Active
    <QueriedDisclaimer tag="kodiaq-fl-active-disclaimer" size={18} mdxType="QueriedDisclaimer" />, Ambition и
    Style с расширенным перечнем стандартного оснащения, а также в версиях SPORTLINE
    и L&K. Моторная гамма для модели предусматривает три бензиновых и один дизельный
    двигатель объемом от 1,4 л до 2,0 л и мощностью от 125 л.с. до 180 л.с.
  </DefaultSectionText>
    </DefaultPaddedSection>
    <FeaturesSliderQueried simpleBlock bgColor="FAFAFA" tags="kodiaqFL2021-new-tech" filterTags={[{
      name: "Active",
      tag: "active"
    }, {
      name: "Ambition",
      tag: "ambition"
    }, {
      name: "Style",
      tag: "style"
    }]} mdxType="FeaturesSliderQueried" />
    <DefaultPaddedSection tag="Kodiaq" bgColor="#FAFAFA" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">
    ОБЗОР 360° ОБНОВЛЕННОГО ŠKODA KODIAQ
  </DefaultSectionHeading>
  <CustomIFrame key="Kodiaq" lazy adaptive height="700px" src="https://virtual-test-drive.skoda-avto.ru/NewKodiaq" previewSrc="/m/new-kodiaq-vtd-new.png" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen mdxType="CustomIFrame" />
    </DefaultPaddedSection>
    <div id="test-drive"></div>
    <DefaultPaddedSection noPs bgColor="#FFF" mdxType="DefaultPaddedSection">
  <AvnWidget tags="avnwidget-kodiaq" mdxType="AvnWidget" />
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FAFAFA" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">
    ВИДЕО ОБ ОБНОВЛЕННОМ ŠKODA KODIAQ
  </DefaultSectionHeading>
    </DefaultPaddedSection>
    <VideoPlayer padding="16/9" previewSrc="/m/preview-video-kodiaq-fl.jpg" videoSrc={{
      "video/mp4": "/m/kodiaq-fl-30s-compress.mp4"
    }} mdxType="VideoPlayer" />
    <DefaultPaddedSection bgColor="#FFF" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">
    Оригинальные детали и аксессуары ŠKODA
  </DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    Вы всегда можете подобрать необходимые оригинальные детали или аксессуары
    для Вашего автомобиля ŠKODA, воспользовавшись нашим онлайн-магазином.
  </DefaultSectionText>
  <PaddedTilesContainer mdxType="PaddedTilesContainer">
    <PaddedTilesTile imgSrc="/m/all_pages_parts.png" title="оригинальные аксессуары ŠKODA" href="https://parts.skoda-avto.ru/accessories" linkText="Перейти в каталог" mdxType="PaddedTilesTile" />
    <PaddedTilesTile imgSrc="/m/all_pages_acc.png" title="Оригинальные детали ŠKODA" href="https://parts.skoda-avto.ru/" linkText="Перейти в каталог" mdxType="PaddedTilesTile" />
  </PaddedTilesContainer>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FAFAFA" noPt mdxType="DefaultPaddedSection">
  <Slider slidesToShow={1} mdxType="Slider">
    <SlideIcon key="/m/subscribe.svg" icon="/m/subscribe.svg" title="Подписаться" text=" Подпишитесь на новости о ŠKODA" buttonText="Подписаться на новости" buttonLink="/subscribe" mdxType="SlideIcon" />
  </Slider>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FFF" noPb mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">Где купить</DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    Дилерские центры ŠKODA расположены таким образом, чтобы Вы могли в любой
    момент обратиться в любой из них по интересующему Вас вопросу, будь то
    запись на плановое ТО, покупка нового автомобиля или сдача старого в
    trade-in. Здесь Вы найдете всю необходимую информацию для связи с дилером.
  </DefaultSectionText>
    </DefaultPaddedSection>
    <QueriedDlNew mdxType="QueriedDlNew" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      